// browser with Touch Events
// or Pointer Events running on touch-capable device
// navigator.msMaxTouchPoints for microsoft IE backwards compatibility
// hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
export const  userDeviceHasTouchScreen = (_window) =>
  'ontouchstart' in _window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

